import React from 'react';
import PropTypes from 'prop-types';

const Row = ({ left, right }) => (
  <div className="row mb2">
    <div className="col-md-6">{left}</div>
    <div className="col-md-6">{right}</div>
  </div>
);

Row.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node
};

Row.defaultProps = {
  left: null,
  right: null
};

export default Row;
